import { compose } from 'redux'

import withRedux from './withRedux'
import withState from './withState'
import withEventHandlers from './withEventHandlers'
import withAllergyEventHandlers from './withAllergyEventHandlers'

import UI from './UI'

export default compose(
  withRedux, // for managing modal state
  withState,
  withEventHandlers,
  withAllergyEventHandlers
)(UI)
